/**
 * Offer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CreditApplication } from './creditApplication';
import { TrackingData } from './trackingData';


export interface Abort { 
    id?: string;
    testMode?: boolean;
    state?: Abort.StateEnum;
    page?: string;
    ssoUserId?: string;
    customerId?: string;
    creditApplication?: CreditApplication;
    tracking?: TrackingData;
    createdAt?: string;
    modifiedAt?: string;
    fromIncomplete?: boolean;
    incompleteReason?: string;
}
export namespace Abort {
    export type StateEnum = 'NEW' | 'ABORT' | 'COMPLETED';
    export const StateEnum = {
        New: 'NEW' as StateEnum,
        Abort: 'ABORT' as StateEnum,
        Completed: 'COMPLETED' as StateEnum
    };
}


